<template>
  <div>
    <validation-provider v-if="offerEdition" #default="{ errors }" :name="$t('offer.subscription.specifics.max_fuel_airports')" rules="numeric">
      <b-form-group :label="$t('offer.subscription.specifics.max_fuel_airports')" label-for="offer-subscription-specifics-max-fuel-airports">
        <b-overlay :show="offerSubscriptionLoading">
          <b-form-input
            id="offer-subscription-specifics-max-fuel-airports"
            v-model="items.maxFuelAirports"
            type="number"
            number
            :placeholder="$t('offer.subscription.specifics.max_fuel_airports')"
          />
        </b-overlay>
        <b-tooltip v-if="errors[0]" show target="offer-subscription-specifics-max-fuel-airports" placement="bottom" variant="light">
          <small class="text-danger">{{ errors[0] }}</small>
        </b-tooltip>
      </b-form-group>
    </validation-provider>
    <span v-else>{{ $t('offer.subscription.specifics.max_fuel_airports') }} : {{ items.maxFuelAirports ? items.maxFuelAirports : $t('offer.subscription.specifics.max_fuel_airports_illimited') }}</span>
  </div>
</template>

<script>
export default {
  name: 'OfferPartSubscriptionOptionsFuelAirport',

  props: {
    items: {
      type: Object,
      required: true,
    },
    offerSubscriptionLoading: {
      type: Boolean,
      required: true,
    },
    offerEdition: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
